import classNames from 'classnames'
import { TFunction } from 'i18next'
import * as React from 'react'
import { withTranslation } from 'react-i18next'
import ShopNowLink from '../shopNowLink'
import { styles } from './styles'

interface BrandItemProps {
  name: string
  brandLogo: any
  cashBack?: string
  isCashbackShownInWebsite?: boolean
  isActive?: boolean
  customStyle: any
  t: TFunction
  link: string
  originalUrl?: string
  isCardOnLanding?: boolean
  onClick: () => void
}

const BrandItemUser = ({
  name,
  brandLogo,
  link,
  originalUrl,
  cashBack,
  isCashbackShownInWebsite = true,
  isActive,
  customStyle,
  isCardOnLanding,
  onClick,
  t,
  ...props
}: BrandItemProps) => {
  const classes = styles()
  const cashBackClasses = classNames({
    [classes.cashBackText]: true,
    [classes.cashBackTextActive]: isActive,
    [customStyle]: customStyle,
  })

  const cardBackground = isCardOnLanding ? classes.whiteCard : ''

  return (
    <div className={`${classes.card} ${cardBackground}`}>
      <ShopNowLink href={link} originalUrl={originalUrl} onClick={onClick}>
        <img src={brandLogo} alt={name} className={classes.logo} />
        {cashBack && isCashbackShownInWebsite ? (
          <p className={cashBackClasses}>
            {cashBack} {t('home.cashBack')}
          </p>
        ) : (
          <p className={cashBackClasses}>{t('home.shopNow')}</p>
        )}
      </ShopNowLink>
    </div>
  )
}

export default withTranslation()(BrandItemUser)
